/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCapsuleHorizontalFilled = createReactComponent("filled", "capsule-horizontal-filled", "IconCapsuleHorizontalFilled", [["path", { "d": "M15 5h-6a7 7 0 1 0 0 14h6a7 7 0 0 0 7 -7l-.007 -.303a7 7 0 0 0 -6.993 -6.697z", "key": "svg-0" }]]);

export { IconCapsuleHorizontalFilled as default };
//# sourceMappingURL=IconCapsuleHorizontalFilled.mjs.map
